import { Authorities } from "./authorities.component";
import { Authority } from "./authority.component";
import { EditAuthority } from "./authority.edit.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { authoritiesState, authorityState, newAuthorityState, editAuthorityState } from "./authorities.states";
import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";

import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";

let AUTHORITY_STATES = [authoritiesState, authorityState, newAuthorityState, editAuthorityState];

import { ConfirmDialog } from "../../shared/confirm-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: AUTHORITY_STATES })
    ],
    declarations: [Authorities, Authority, EditAuthority],
    entryComponents: [ConfirmDialog]
})
export default class AuthoritiesModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/authorities/authorities.module.ts